import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import type { HelpWidgetMessage } from "../types/help_widget_message";
import { ChatMessage } from "./common/ChatMessage";
import { HelpInputArea } from "./common/HelpInputArea";

export const ChatView = ({
  messages,
  onSendMessage,
}: {
  messages: HelpWidgetMessage[];
  onSendMessage: (text: string) => void;
}) => (
  <div className="flex flex-1 flex-col">
    <div className="flex flex-1 flex-col gap-5">
      {messages?.map((message: HelpWidgetMessage) => (
        <ChatMessage
          key={message.id}
          authorName={message.author_name}
          content={message.content}
          createdAt={message.created_at.toLocaleString()}
          type={
            message.author_type === "agent" ? "business" : message.author_type
          }
          buttons={[]}
          showDisclaimer={false}
        />
      ))}
    </div>
    <div className="sticky bottom-0 z-10 p-4">
      <HelpInputArea
        onSubmit={onSendMessage}
        placeholder={t("help_widget.conversation_page.help_input_placeholder")}
      />
    </div>
    <div className="sticky bottom-0 flex justify-center rounded-lg px-4 pb-4">
      <Typography.BodySm color="text-tertiary">
        {t("help_widget.conversation_page.footer_message")}
        <Icon type="info" size={14} />
      </Typography.BodySm>
    </div>
  </div>
);
